module.exports = __webpack_public_path__ + "static/media/freo.393d799e.svg";